import React from "react";
import { object } from "prop-types";
import FourColPortraitStories from "../../../../arrow/components/Rows/FourColPortraitStories";

export const ArrowAFourColPortraitStories= ({ collection }) => {
  const config = {
    buttonText: `${collection.name} News`,
  };
  return <FourColPortraitStories collection={collection} config={config} />;
};

ArrowAFourColPortraitStories.propTypes = {
  collection: object,
};

ArrowAFourColPortraitStories.storyLimit = 11;
